import styled from 'styled-components';

const StyledRowAwards = styled.div`
  padding-bottom: ${props => props.theme.components_spacing_desk.medium}px;
  &:last-child{
    padding-bottom: 0;
  }
  h5{
    color: ${props => props.theme.colors.green_secondary};
    padding-bottom: ${props => props.theme.components_spacing_desk.small}px;
  }
  p{
    color: ${props => props.theme.colors.grey_700};
    padding-bottom: 24px;
  }
  p:last-child{
    padding-bottom: 0
  }
 
  @media screen and (max-width: 1023px){
    padding-bottom: ${props => props.theme.components_spacing_tablet.medium}px;;
    h5{
      padding-bottom: ${props => props.theme.components_spacing_tablet.small}px;
    }
  }
  @media screen and (max-width: 767px){
    padding-bottom: ${props => props.theme.components_spacing_mobile.medium}px;
    h5{
      padding-bottom: ${props => props.theme.components_spacing_tablet.small}px;
    }
    p{
      padding-bottom: 16px;
    }
    p:last-child{
      padding-bottom: 0
    }
  }
`;

export {
  StyledRowAwards,
};

